/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ExamLoginMaxLengthSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('EXAM_LOGIN_MAX_LENGTH')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class ExamLoginMaxLengthSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ExamLoginMaxLengthSettingParser.decode(input).map(res => new ExamLoginMaxLengthSetting(res));
    }
    static unsafeDecode(input) {
        return ExamLoginMaxLengthSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExamLoginMaxLengthSettingParser.encode(data);
    }
    static schema() {
        return ExamLoginMaxLengthSettingParser.schema();
    }
}
